// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcw_a bho_b bho_tu bho_qz bho_ra bho_uo","PanelFooter--link":"bcw_b"};